const LOGGER_FORCE_HIDE_LOCAL_STORE_KEY = 'LOGGER_FORCE_HIDE';
const LOGGER_SHOW_EVENTS_LOCAL_STORE_KEY = 'LOGGER_SHOW_EVENTS';
const LOGGER_SHOW_LOGS_LOCAL_STORE_KEY = 'LOGGER_SHOW_LOGS';
const LOGGER_SHOW_MINIMAL_LOCAL_STORE_KEY = 'LOGGER_MINIMAL';

export {
  LOGGER_FORCE_HIDE_LOCAL_STORE_KEY,
  LOGGER_SHOW_EVENTS_LOCAL_STORE_KEY,
  LOGGER_SHOW_LOGS_LOCAL_STORE_KEY,
  LOGGER_SHOW_MINIMAL_LOCAL_STORE_KEY,
};
